module.exports = __webpack_public_path__ + "static/flags/RM-873982926c639b4de754b9d3f66c063b.gif";